import React, { ReactNode, useEffect, useState } from 'react';
import {
  CookbookProvider,
  grubhubLight,
  seamlessLight,
  CookbookTheme,
} from '@grubhubprod/gh-cookbook-react/dist';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { Brands } from 'src/utilities/shared-types';
import { MODAL_ROOT_ID } from 'src/components/Modal/Modal';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';

interface ICookbookWrapperProps {
  children: ReactNode;
}

const CookbookWrapper = ({ children }: ICookbookWrapperProps): JSX.Element => {
  const { user } = useAuth();
  const { value: enableAuditMode } = useFeatureFlag(
    FeatureFlag.ENABLE_COOKBOOK_AUDIT_MODE
  );

  const [cookbookTheme, setCookbookTheme] =
    useState<CookbookTheme>(grubhubLight);

  useEffect(() => {
    setCookbookTheme(
      user?.brand === Brands.SEAMLESS ? seamlessLight : grubhubLight
    );
  }, [user?.brand]);

  return (
    <CookbookProvider theme={cookbookTheme} enableAuditMode={enableAuditMode}>
      <div id={MODAL_ROOT_ID} />

      {children}
    </CookbookProvider>
  );
};

export default CookbookWrapper;
